import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { RliSdk } from '@rocketlane/rli-internal-sdk';
import { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { MARKETPLACE_SERVICE_BE_URL } from 'config/environment';
import { ExpenseEventsMap } from 'events/expenses';
import { ProjectEventsMap } from 'events/projects';
import { ResourceRequestEventsMap } from 'events/resource-request';
import { TaskEventsMap } from 'events/tasks';
import { useGetInstalledMarketplaceApps, useGetMarketplaceAuthToken } from 'marketplace/hooks/use-marketplace-hooks';
import { useWidgetCommunicationHandler } from 'marketplace/hooks/use-widget-communication-handler';
export const IframeWrapper = styled.div`
  display: none;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;
const AddMarketplaceClientEventScripts = ({ version })=>{
    const { registerCallbacks, show } = useWidgetCommunicationHandler(version.appId, {
        isCustomerPortal: false,
        isLds: false
    });
    const iframeRef = useRef(null);
    const { data: marketplaceAuthToken } = useGetMarketplaceAuthToken();
    useEffect(()=>{
        if (iframeRef.current === null && (marketplaceAuthToken === null || marketplaceAuthToken === void 0 ? void 0 : marketplaceAuthToken.token)) {
            var _version_clientEvents_replaceAll_replaceAll_replaceAll, _version_clientEvents_replaceAll_replaceAll, _version_clientEvents_replaceAll, _version_clientEvents;
            const clientEventsSrc = `${(_version_clientEvents = version.clientEvents) === null || _version_clientEvents === void 0 ? void 0 : (_version_clientEvents_replaceAll = _version_clientEvents.replaceAll('./', '/')) === null || _version_clientEvents_replaceAll === void 0 ? void 0 : (_version_clientEvents_replaceAll_replaceAll = _version_clientEvents_replaceAll.replaceAll('//', '/')) === null || _version_clientEvents_replaceAll_replaceAll === void 0 ? void 0 : (_version_clientEvents_replaceAll_replaceAll_replaceAll = _version_clientEvents_replaceAll_replaceAll.replaceAll('https:/', 'https://')) === null || _version_clientEvents_replaceAll_replaceAll_replaceAll === void 0 ? void 0 : _version_clientEvents_replaceAll_replaceAll_replaceAll.replaceAll('https:///', 'https://')}`;
            RliSdk === null || RliSdk === void 0 ? void 0 : RliSdk.registerWidget({
                appId: version.appId,
                apiKey: marketplaceAuthToken === null || marketplaceAuthToken === void 0 ? void 0 : marketplaceAuthToken.token,
                baseUrl: MARKETPLACE_SERVICE_BE_URL,
                id: `marketplace-client-events${version.appVersionId}`,
                src: clientEventsSrc,
                widgetIdentifier: `marketplace-client-events-${version.appId}-${version.appVersionId}`,
                events: {
                    ...TaskEventsMap,
                    ...ProjectEventsMap,
                    ...ExpenseEventsMap,
                    ...ResourceRequestEventsMap
                },
                data: {
                    GET_USER_DATA: 'user',
                    // GET_USER_PROJECTS: 'user_projects',
                    GET_USER_ACCOUNT: 'account'
                },
                parent: document.getElementById(`marketplace-client-events${version.appVersionId}`)
            }).then((widget)=>{
                iframeRef.current = widget;
                registerCallbacks(widget);
            });
        }
        return ()=>{
            if (iframeRef.current) {
                var _iframeRef_current, _RliSdk_deRegisterWidget;
                RliSdk === null || RliSdk === void 0 ? void 0 : (_RliSdk_deRegisterWidget = RliSdk.deRegisterWidget) === null || _RliSdk_deRegisterWidget === void 0 ? void 0 : _RliSdk_deRegisterWidget.call(RliSdk, (_iframeRef_current = iframeRef.current) === null || _iframeRef_current === void 0 ? void 0 : _iframeRef_current.id);
                iframeRef.current = null;
            }
        };
    }, [
        version,
        registerCallbacks,
        show,
        marketplaceAuthToken === null || marketplaceAuthToken === void 0 ? void 0 : marketplaceAuthToken.token
    ]);
    return /*#__PURE__*/ _jsx(IframeWrapper, {
        id: `marketplace-client-events${version.appVersionId}`
    });
};
export const AddMarketplaceClientEventScriptsForAllApps = ()=>{
    const [enableMarketplaceClientEventScripts, setEnableMarketplaceClientEventScripts] = useState(false);
    const { data: installedMarketplaceApps = [] } = useGetInstalledMarketplaceApps(enableMarketplaceClientEventScripts);
    const appsWithClientEvents = useMemo(()=>installedMarketplaceApps.filter((app)=>{
            var _app_version, _app_installation;
            return (app === null || app === void 0 ? void 0 : (_app_version = app.version) === null || _app_version === void 0 ? void 0 : _app_version.clientEvents) && !(app === null || app === void 0 ? void 0 : (_app_installation = app.installation) === null || _app_installation === void 0 ? void 0 : _app_installation.disabled);
        }), [
        installedMarketplaceApps
    ]);
    useEffect(()=>{
        const timeOut = setTimeout(()=>{
            setEnableMarketplaceClientEventScripts(true);
        }, 2000);
        return ()=>clearTimeout(timeOut);
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: appsWithClientEvents.map((app)=>{
            var _ref;
            var _app_version;
            return /*#__PURE__*/ _jsx(AddMarketplaceClientEventScripts, {
                version: app.version
            }, (_ref = (_app_version = app.version) === null || _app_version === void 0 ? void 0 : _app_version.appVersionId) !== null && _ref !== void 0 ? _ref : '');
        })
    });
};
